<script setup lang="ts">
import type { ControlSize, ControlWidth } from './context';
import { provideControlDefaults } from './context';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = withDefaults(defineProps<{
    size?: ControlSize
    /** Width for the free-text controls inside; date and time pickers keep the width of their format. */
    width?: ControlWidth
}>(), {
    size: undefined,
    width: undefined,
});

provideControlDefaults(() => ({ size: props.size, width: props.width }));
</script>

<template>
    <slot></slot>
</template>
